import React, { useState } from 'react'

// Utils
import { getParsedItem, setStringifiedItem } from '@sketch/utils'

// Constants
import { localStorageKeys } from '@sketch/constants'

// Styles
import { Wrapper, StyledBannerCard } from './BannerCardList.styles'

import { Banner } from '../BannerCardList/Banners'
// Types
interface BannerCardListProps {
  // Maximum number of banners to render
  maxBanners?: number
  // List of banners to render
  banners: Banner[]
  // Render the smallest version of the BannerCard
  smallBanners?: boolean
  // All Banners cannot be dismissed
  nonDismissable?: boolean
}

/** Renders a given list of BannerCards */
const BannerCardList: React.FC<BannerCardListProps> = ({
  maxBanners = 2,
  banners,
  smallBanners,
  nonDismissable,
}) => {
  const [dismissedBannerCards, setDismissedBannerCards] = useState<string[]>(
    getParsedItem(localStorageKeys.dismissedBannerCards) ?? []
  )

  const handleDismiss = (dismissedBannerCard: string) => {
    if (!dismissedBannerCards.includes(dismissedBannerCard)) {
      const currentDismissedBannerCards = [
        dismissedBannerCard,
        ...dismissedBannerCards,
      ]

      // Set the current BannerCard ID to the list of dismissed banners
      setStringifiedItem(
        localStorageKeys.dismissedBannerCards,
        currentDismissedBannerCards
      )

      setDismissedBannerCards(currentDismissedBannerCards)
    }
  }

  const renderableBanners = banners.filter(
    banner => !dismissedBannerCards.includes(banner.id)
  )

  const croppedBanners: Banner[] = renderableBanners.slice(0, maxBanners)

  if (!croppedBanners.length) {
    return null
  }

  return (
    <Wrapper>
      {croppedBanners.map(({ id, ...props }) => (
        <StyledBannerCard
          key={id}
          id={id}
          {...props}
          small={smallBanners}
          onDismiss={
            nonDismissable
              ? undefined
              : props?.isDismissable
              ? handleDismiss
              : undefined
          }
        />
      ))}
    </Wrapper>
  )
}

export default BannerCardList
